import React, { useState } from 'react';
import axios from 'axios';
import './Pages.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCTS = [
  "Ashwagandha Root Powder",
  "Moringa Leaf Powder",
  "Turmeric Powder",
  "Ginger Powder",
  "Amla Powder",
  "Neem Powder",
  "Other (specify in notes)"
];

function RequestSamplePage() {
  const [formData, setFormData] = useState({
    full_name: '',
    company_name: '',
    country: '',
    whatsapp: '',
    product: '',
    sample_quantity: '',
    shipping_address: '',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await axios.post(`${API}/sample-request`, formData);
      setSubmitStatus({ type: 'success', message: response.data.message });
      setFormData({
        full_name: '',
        company_name: '',
        country: '',
        whatsapp: '',
        product: '',
        sample_quantity: '',
        shipping_address: '',
        notes: ''
      });
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Failed to submit. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="page-container form-page">
      <div className="page-header">
        <h1>Request a Sample</h1>
        <div className="title-underline"></div>
      </div>
      
      <div className="page-intro">
        <p>We provide samples for buyer evaluation. Share your details and product requirement to proceed.</p>
      </div>

      {submitStatus?.type === 'success' ? (
        <div className="success-message">
          <div className="success-icon">✓</div>
          <h3>Thank you!</h3>
          <p>{submitStatus.message}</p>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="request-form">
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input type="text" name="full_name" value={formData.full_name} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>Company Name</label>
              <input type="text" name="company_name" value={formData.company_name} onChange={handleChange} />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Country *</label>
              <input type="text" name="country" value={formData.country} onChange={handleChange} required />
            </div>
            <div className="form-group">
              <label>WhatsApp Number *</label>
              <input type="tel" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required placeholder="+1234567890" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Product Interested In *</label>
              <select name="product" value={formData.product} onChange={handleChange} required>
                <option value="">Select Product</option>
                {PRODUCTS.map(p => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Sample Quantity Required *</label>
              <input type="text" name="sample_quantity" value={formData.sample_quantity} onChange={handleChange} required placeholder="e.g., 100g, 500g" />
            </div>
          </div>

          <div className="form-group full-width">
            <label>Shipping Address *</label>
            <textarea name="shipping_address" value={formData.shipping_address} onChange={handleChange} rows="3" required placeholder="Full shipping address with postal code"></textarea>
          </div>

          <div className="form-group full-width">
            <label>Notes (optional)</label>
            <textarea name="notes" value={formData.notes} onChange={handleChange} rows="3" placeholder="Any additional notes..."></textarea>
          </div>

          {submitStatus?.type === 'error' && (
            <div className="error-message">{submitStatus.message}</div>
          )}

          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Submitting...' : 'Submit Sample Request'}
          </button>
        </form>
      )}
    </div>
  );
}

export default RequestSamplePage;
